export enum Ancestor {
  Filters = 'Filters',
  ListingPreview = 'ListingPreview',
  Menu = 'Menu',
  Overview = 'Overview',
  Playlist = 'Playlist',
  ReviewsBadge = 'ReviewsBadge',
  ReviewsDrawer = 'ReviewsDrawer',
  SlideoutDrawer = 'SlideoutDrawer',
}
